import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { GeralService } from '@gestor-web/app/shared/services';
import { SelectItem } from 'primeng/api';
import { Popover } from 'primeng/popover';
import { Observable, map } from 'rxjs';

export interface FilterData {
  nr_cnpj_cpf_exec?: string;
  tp_rede?: string;
  id_origem_guia?: string;
}

@Component({
    selector: 'bl-analises-filtro',
    templateUrl: './filtro.component.html',
    styleUrls: ['./filtro.component.scss'],
    standalone: false
})
export class AnalisesFiltroComponent implements OnInit, OnChanges {
  @ViewChild('filter') filter: Popover;

  @Input() data: FilterData;

  @Output() dataChange = new EventEmitter<FilterData>();
  @Output() onChange = new EventEmitter<FilterData>();

  tipoRedeOptions$: Observable<SelectItem<string>[]>;
  idOrigemGuia$: Observable<SelectItem<string>[]>;

  initialData: FilterData;

  count = 0;
  label = '';

  formGroup = this.fb.group({
    nr_cnpj_cpf_exec: [null],
    tp_rede: [null],
    id_origem_guia: [null],
  });

  constructor(
    private geralService: GeralService,
    private fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    // console.log('[Filtro] ngOnInit', this.data);

    this.initialData = this.data;
    this.updateLabel();

    this.tipoRedeOptions$ = this.geralService.getDominioPorTipo('MON_TIPO_REDE').pipe(
      map(items => {
        const options = items.map(item => ({ label: item.ds_exibicao, value: item.cd_valor_valido }) as SelectItem);
        options.unshift({ label: 'Todos', value: null });
        return options;
      }),
    );
    this.idOrigemGuia$ = this.geralService.getDominioPorTipo('dm_origemEventoAtencaoSaude').pipe(
      map(items => {
        const options = items.map(item => ({ label: item.ds_exibicao, value: item.cd_valor_valido }) as SelectItem);
        options.unshift({ label: 'Todos', value: null });
        return options;
      }),
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('[Filtro] ngOnChanges', changes);
    if (changes['data']) {
      this.updateLabel();
    }
  }

  private updateLabel() {
    // console.log('[Filtro] updateLabel');
    this.count = Object.entries(this.data).filter(([k, v]) => this.formGroup.contains(k) && !!v).length;
    if (this.count == 0) {
      this.label = '';
    } else {
      this.label = this.count + ' filtro' + (this.count > 1 ? 's' : '');
    }
    // console.log('[Filtro] updateLabel ... ', this.count, this.label);
  }

  onShow($event) {
    // console.log('[Filtro] onShow', this.formGroup.value, this.data);

    this.formGroup.patchValue(this.data);
    this.filter.toggle($event);
  }

  onApply() {
    // console.log('[Filtro] onApply', this.formGroup.value, this.data);

    const value = this.formGroup.value;
    if (value.nr_cnpj_cpf_exec) {
      value.nr_cnpj_cpf_exec = value.nr_cnpj_cpf_exec.replace(/[.\-/\s]/g, '').toUpperCase();
    }

    this.data = value;
    this.count = Object.values(this.data).reduce((acc, val) => (acc + !!val ? 1 : 0), 0);
    if (this.count == 0) {
      this.label = '';
    } else {
      this.label = this.count + ' filtro' + (this.count > 1 ? 's' : '');
    }

    this.dataChange.emit(this.data);
    this.onChange.emit(this.data);
  }

  onClear() {
    // console.log('[Filtro] onClear', this.formGroup.value, this.data);

    this.formGroup.reset();
    this.data = this.initialData;
    this.count = 0;
    this.label = '';

    this.dataChange.emit(this.data);
    this.onChange.emit(this.data);
  }
}
